module.exports = __webpack_public_path__ + "static/media/80.ed1e3a19.png";